import React from 'react'
import { useMediaQuery } from 'react-responsive'

const HomeSmallBanner = ({ props }) => {
  const { backgroundImage, image, title, text } = props
  const isMobileVersion = useMediaQuery({ maxWidth: 420 })

  return (
    <section
      style={{
        backgroundImage: `url(${backgroundImage?.fields.file.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
      className="home-small-banner-container"
      aria-label={title}
    >
      <div className="dealmed-small-content-banner">
        <div className="dealmed-small-content-banner__text-wrapper">
          <h2 className="dealmed-content-banner__title">{title}</h2>
          <p className="dealmed-small-content-banner__text">{text}</p>
        </div>
        <>
          {!isMobileVersion && (
            <div className="dealmed-small-content-banner__image-wrapper">
              <img
                src={image?.fields.file.url}
                className="dealmed-small-content-banner__image"
                alt=""
                loading="lazy"
              />
              {/* <img src={imageFile.fields.file.url} className="dealmed-content-banner__image" alt="" /> */}
            </div>
          )}
        </>
      </div>
    </section>
  )
}

export default HomeSmallBanner
